<template>
	<div v-show="!empty" class="m-operate flex-between-center" :empty="empty" :border="border">
		<div class="m-operate-group flex-center-cross">
			<slot></slot>
		</div>
		<div class="m-operate-group flex-center-cross">
			<slot name="right"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mOperate',

		props: {
			border: Boolean
		},

		data() {
			return {
				empty: true
			}
		},

		mounted() {
			this.empty = !this.$children.length;
		},

		updated() {
			this.empty = !this.$children.length;
		}
	}
</script>

<style lang="stylus" scoped>
	.m-operate {
		border: 1px solid var(--table-border);
		border-width: 1px 0 0;
		padding: 6px 12px;
		background: #FAFAFA;

		&[border] {
			border-width: 1px 1px 0;
		}

		&-group {
			gap: 8px;
		}

		>>> .c-input {
			height: 30px;
		}
	}
</style>
